export default __webpack_public_path__ + "static/media/drag-drop-icon-w.3c463dc6.svg";